<template>
  <div class="mb-24">
    <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
      <div class="bg-theme-green px-4 py-2 text-white">
        <div class="flex justify-between items-center">
          <div class="font-semibold tracking-wider leading-tight text-2xl mt-0">
            <span class=" truncate text-single-line break-all">{{ item.name ? item.name : 'Edit New POS'}}</span>
            <svg width="30" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12.5C8.16667 12.5 7.45833 12.2083 6.875 11.625C6.29167 11.0417 6 10.3333 6 9.5V3C6 2.16667 6.29167 1.45833 6.875 0.875C7.45833 0.291667 8.16667 0 9 0H31C31.8333 0 32.5417 0.291667 33.125 0.875C33.7083 1.45833 34 2.16667 34 3V9.5C34 10.3333 33.7083 11.0417 33.125 11.625C32.5417 12.2083 31.8333 12.5 31 12.5H9ZM9 9.5H31V3H9V9.5ZM3 40C2.16667 40 1.45833 39.7083 0.875 39.125C0.291667 38.5417 0 37.8333 0 37V33.5H40V37C40 37.8333 39.7083 38.5417 39.125 39.125C38.5417 39.7083 37.8333 40 37 40H3ZM0 32L7.25 15.8C7.51667 15.2333 7.88333 14.7917 8.35 14.475C8.81667 14.1583 9.35 14 9.95 14H30.05C30.65 14 31.1833 14.1583 31.65 14.475C32.1167 14.7917 32.4833 15.2333 32.75 15.8L40 32H0ZM13 28H15C15.2667 28 15.5 27.9 15.7 27.7C15.9 27.5 16 27.2667 16 27C16 26.7333 15.9 26.5 15.7 26.3C15.5 26.1 15.2667 26 15 26H13C12.7333 26 12.5 26.1 12.3 26.3C12.1 26.5 12 26.7333 12 27C12 27.2667 12.1 27.5 12.3 27.7C12.5 27.9 12.7333 28 13 28ZM13 24H15C15.2667 24 15.5 23.9 15.7 23.7C15.9 23.5 16 23.2667 16 23C16 22.7333 15.9 22.5 15.7 22.3C15.5 22.1 15.2667 22 15 22H13C12.7333 22 12.5 22.1 12.3 22.3C12.1 22.5 12 22.7333 12 23C12 23.2667 12.1 23.5 12.3 23.7C12.5 23.9 12.7333 24 13 24ZM13 20H15C15.2667 20 15.5 19.9 15.7 19.7C15.9 19.5 16 19.2667 16 19C16 18.7333 15.9 18.5 15.7 18.3C15.5 18.1 15.2667 18 15 18H13C12.7333 18 12.5 18.1 12.3 18.3C12.1 18.5 12 18.7333 12 19C12 19.2667 12.1 19.5 12.3 19.7C12.5 19.9 12.7333 20 13 20ZM19 28H21C21.2667 28 21.5 27.9 21.7 27.7C21.9 27.5 22 27.2667 22 27C22 26.7333 21.9 26.5 21.7 26.3C21.5 26.1 21.2667 26 21 26H19C18.7333 26 18.5 26.1 18.3 26.3C18.1 26.5 18 26.7333 18 27C18 27.2667 18.1 27.5 18.3 27.7C18.5 27.9 18.7333 28 19 28ZM19 24H21C21.2667 24 21.5 23.9 21.7 23.7C21.9 23.5 22 23.2667 22 23C22 22.7333 21.9 22.5 21.7 22.3C21.5 22.1 21.2667 22 21 22H19C18.7333 22 18.5 22.1 18.3 22.3C18.1 22.5 18 22.7333 18 23C18 23.2667 18.1 23.5 18.3 23.7C18.5 23.9 18.7333 24 19 24ZM19 20H21C21.2667 20 21.5 19.9 21.7 19.7C21.9 19.5 22 19.2667 22 19C22 18.7333 21.9 18.5 21.7 18.3C21.5 18.1 21.2667 18 21 18H19C18.7333 18 18.5 18.1 18.3 18.3C18.1 18.5 18 18.7333 18 19C18 19.2667 18.1 19.5 18.3 19.7C18.5 19.9 18.7333 20 19 20ZM25 28H27C27.2667 28 27.5 27.9 27.7 27.7C27.9 27.5 28 27.2667 28 27C28 26.7333 27.9 26.5 27.7 26.3C27.5 26.1 27.2667 26 27 26H25C24.7333 26 24.5 26.1 24.3 26.3C24.1 26.5 24 26.7333 24 27C24 27.2667 24.1 27.5 24.3 27.7C24.5 27.9 24.7333 28 25 28ZM25 24H27C27.2667 24 27.5 23.9 27.7 23.7C27.9 23.5 28 23.2667 28 23C28 22.7333 27.9 22.5 27.7 22.3C27.5 22.1 27.2667 22 27 22H25C24.7333 22 24.5 22.1 24.3 22.3C24.1 22.5 24 22.7333 24 23C24 23.2667 24.1 23.5 24.3 23.7C24.5 23.9 24.7333 24 25 24ZM25 20H27C27.2667 20 27.5 19.9 27.7 19.7C27.9 19.5 28 19.2667 28 19C28 18.7333 27.9 18.5 27.7 18.3C27.5 18.1 27.2667 18 27 18H25C24.7333 18 24.5 18.1 24.3 18.3C24.1 18.5 24 18.7333 24 19C24 19.2667 24.1 19.5 24.3 19.7C24.5 19.9 24.7333 20 25 20Z" fill="white"/>
            </svg>
          </div>
          <div class="flex items-end">
            <button @click.prevent="update()" class="  tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3">
                SAVE
              </button>
              <button @click.prevent="deleteRecord()" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4  hover:bg-theme-darkgreen hover:text-white mr-3">DELETE</button>
              <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
            <!-- <mdicon @click.prevent="clearComponent" size="32" class="close-icon flex justify-end cursor-pointer hover:opacity-60 mb-2 " name="close" />
            <div class="flex justify-between">
                <button @click="update()" class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase font-semibold">SAVE</button>
                <mdicon  @click="deleteRecord()" name="trash-can-outline" class="hover:bg-theme-red hover:text-white del-icon border-0 rounded-md cursor-pointer text-theme-red bg-white ml-2 pt-2 py-1 px-1" />
              </div> -->
          </div>
        </div>
      </div>

      <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
        <div class="mb-3">
          <div class="w-full">
            <div class="flex xl:flex-row flex-col gap-3 items-start ">
              <div class="w-full">
                <div :class="'input-wrapper ' + (form.name.error_type)">
                  <label class="text-xs mb-1">Name:</label>
                  <input placeholder="Something Creative!" @keyup="validateFields(['name'])" v-model="form.name.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                </div>
              </div>

              <!-- <div class="w-full xl:w-1/2">
                <div :class="'input-wrapper ' + (form.barcode_scanner_serial.error_type)">
                  <label class="text-xs mb-1">Barcode Scanner Serial:</label>
                  <input placeholder="Something Creative!"  v-model="form.barcode_scanner_serial.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.barcode_scanner_serial.error_message" v-text="form.barcode_scanner_serial.error_message"></p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="flex flex-row">
          <div class="w-full">
            <label class="text-xs mb-1 mt-0">Status:</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" v-model="form.status" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.status ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.status ? 'text-theme-green' : 'text-[#F53333]'">{{form.status ? 'On' : 'Off'}}</span>
            </label>
          </div>
          <div class="w-full">
            <label class="text-xs mb-1 mt-0">Accept Online Orders:</label>
              <label class="flex items-center cursor-pointer xl:mt-2">
              <input type="checkbox" v-model="form.acceptOnlineOrders" class="hidden peer">
              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.acceptOnlineOrders ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
              <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.acceptOnlineOrders ? 'text-theme-green' : 'text-[#F53333]'">{{form.acceptOnlineOrders ? 'On' : 'Off'}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <ReturnConfirmModal v-if="deleteObj.modal" :obj="deleteObj.obj" :closeClick="closeDeleteModal" :actionClick="deleteNow" :heading="'You Are About To Delete ' + deleteObj.obj.name "/>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import LocationPosStationApis from "@/controllers/LocationPosStationApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";

export default defineComponent({
  name: "LocationPosAdd",
  components: {
   ReturnConfirmModal
  },
  setup() {
    const snackbar = useSnackbar();
    const deleteObj = ref({
      modal: false,
      obj: {},
    });
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      // barcode_scanner_serial: {
      //   value: '',
      //   error_type: '',
      //   error_message: '',
      //   validations: ['required'],
      // },
      status: false,
      acceptOnlineOrders: false
    });
    return {
      form,
      snackbar,
      deleteObj
    };
  },
  props:{
    clearComponent: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  watch:{
    'item'(val) {
      this.assignItemValue();
    },
     // Fields cannot have white spaces
    // 'form.barcode_scanner_serial.value'(val){
    //   this.form.barcode_scanner_serial.value = val.replaceAll(/\s/g,'').trim();
    // },
  },

  computed: {
    ...mapGetters({
     
    }),
  },

  mounted() {
    this.assignItemValue();
  },
 
  methods: {

   assignItemValue() {
      this.form.name.value = this.item.name;
      this.form.status = this.item.status;
      this.form.acceptOnlineOrders = this.item.acceptOnlineOrders;
    },
    
     /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },


    /**
     * Add new location Tax
     */
    async update() {
      let validate = await this.validateFields(['name']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let res = await LocationPosStationApis.updateLocationPosStation(this.item.id, {
          name: this.form.name.value,
          status: this.form.status,
          acceptOnlineOrders: this.form.acceptOnlineOrders
      });
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 200 ) {
        this.clearComponent();
        this.emitter.emit("refresh-location-pos-station-list", true);
      }
    },

     /**
     * Delete location tax
     */
    async deleteRecord() {
      this.deleteObj = {
        modal: true,
        obj: this.item,
      };
    },
    
    /**
     * Close delete modal
     */
    closeDeleteModal() {
      this.deleteObj = {
        modal: false,
        obj: {},
      };
    },

    /**
     * Delete Pos
     */
    async deleteNow(obj) {
      this.va_spinner(true);
      let res = await LocationPosStationApis.deleteLocationPosStation(obj.id);
      this.va_spinner(false);
        this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 200 ) {
        this.emitter.emit("refresh-location-pos-station-list", true);
        this.clearComponent();
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>